
import {
    getPagingLawyers,
    getLaywerUserById,
    getLaywerUserEmpty,
} from '../../configs/environments/firebase/firebaseApp'


export const GET_LAWYER_USERS = 'GET_LAWYER_USERS'
export const GET_LAWYER_USERS_BY_ID = 'GET_LAWYER_USERS_BY_ID'
export const GET_LAWYER_USERS_EMPTY = 'GET_LAWYER_USERS_EMPTY'
export const BILLING_LAYWERS = 'BILLING_LAYWERS'
export const CHANGE_TAB = 'CHANGE_TAB'

const laywerPagesLoad = (data) => {
    return {
        type: GET_LAWYER_USERS,
        data
    }
}

const laywerUserByIdLoad = (data) => {
    return {
        type: GET_LAWYER_USERS_BY_ID,
        data
    }
}

const laywerUserEmpty = (data) => {
    return {
        type: GET_LAWYER_USERS_EMPTY,
        data
    }
}

const billingLaywer = (data) => {
    return {
        type: BILLING_LAYWERS,
        data
    }
}

const changingTab = (data) => {
    return {
        type: CHANGE_TAB,
        data
    }
}

export const laywerUserById = uid => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const lawyersUser = await getLaywerUserById(uid)
            dispatch(laywerUserByIdLoad(lawyersUser));
        } catch (error) {
            return reject(error)
        }
    });
}

export const pagingLaywers = (role, page, specialty, state) => (dispatch) =>{
    process_laywer_users_page(dispatch, role, page, specialty, state)
}

export const changeTab = (value) => (dispatch) => {
    let flag
    if (value === 1) {
        flag = 'lawFirm'
    } else if (value === 0) {
        flag = 'lawyer'
    }
    dispatch(changingTab(flag))
}

export const pagingLaywersUp = (role, page, specialty, state) => (dispatch) =>{
    return new Promise(async(resolve, reject) => {
        try {
            let lawyers = await getPagingLawyers(role, page, specialty, state)
            dispatch(laywerPagesLoad(lawyers));
            resolve(true)
        } catch (error) {
            throw error;
            reject(false)
        }

    });
};

export const process_laywer_users = (role, page, specialty, subSpecialty, state) => dispatch => {
    return new Promise(async (resolve, reject) => {
        if (specialty === undefined) specialty = ''
        if (subSpecialty === undefined) subSpecialty = ''
        if (state === undefined) state = ''
        try {
            const lawyers = await getPagingLawyers(role, page, specialty, subSpecialty, state)
            dispatch(laywerPagesLoad(lawyers));
            return resolve(true);
        } catch (error) {
            throw error;
        }
    });
};

export const updatePagingLaywers = (role, page, specialty, subSpecialty, state) => dispatch => {
    return new Promise(async (resolve, reject) => {
        if (specialty === undefined) specialty = '';
        if (state === undefined) state = '';
        if (subSpecialty === undefined) subSpecialty = '';
        try {
            let lawyers = await getPagingLawyers(role, page, specialty, subSpecialty, state)
            dispatch(laywerPagesLoad(lawyers));
            return resolve(true);
        } catch (error) {
            throw error;
        }
    });
}

export const lawyersEmpty = (role) => (dispatch) => {
    process_laywer_user_empty(dispatch, role)
}

// export const createBillingLaywers = (lawyerUid, data) => (dispatch) =>{
//     process_billing_laywer(dispatch, lawyerUid, data)
// }

// export const getBillingLaywers = (lawyerUid) => (dispatch) => {
//     process_get_billing_laywer(dispatch, lawyerUid)
// }

async function process_laywer_users_page (dispatch, role, page, specialty, state){
  
    try {
        let lawyers = await getPagingLawyers(role, page, specialty, state)
        dispatch(laywerPagesLoad(lawyers));

    } catch (error) {
        throw error;
    }
}

async function process_laywer_user_empty (dispatch, role){
    try {
        let lawyersEmpty =  await getLaywerUserEmpty(role)
        dispatch(laywerUserEmpty(lawyersEmpty))
    } catch (error) {
        
    }
}


